import { render } from "./gtin-component.vue?vue&type=template&id=22dcd459&scoped=true"
import script from "./gtin-component.vue?vue&type=script&lang=js"
export * from "./gtin-component.vue?vue&type=script&lang=js"

import "./gtin-component.vue?vue&type=style&index=0&id=22dcd459&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22dcd459"]])

export default __exports__